const UNFORMATTED_CNPJ_REGEX = /^[A-Z0-9]{12}\d{2}$/;
const FORMATTED_CNPJ_REGEX =
  /^[A-Z0-9]{2}\.[A-Z0-9]{3}\.[A-Z0-9]{3}\/[A-Z0-9]{4}-\d{2}$/;

function charToValue(char: string): number {
  return char.charCodeAt(0) - 48;
}

function parseCnpjChars(value: string): string[] | null {
  if (/[a-z]/.test(value)) return null;

  const unformattedOnly = UNFORMATTED_CNPJ_REGEX.test(value);
  const validFormat = FORMATTED_CNPJ_REGEX.test(value);

  if (!unformattedOnly && !validFormat) return null;

  return value.replace(/[./-]/g, '').split('');
}

export default function isCnpjValid(value: string | number | number[]) {
  if (!value) return false;

  const isString = typeof value === 'string';
  const validTypes =
    isString || Number.isInteger(value) || Array.isArray(value);

  if (!validTypes) return false;

  let chars: string[];

  if (isString) {
    if (value.length > 18) return false;

    const parsed = parseCnpjChars(value);
    if (!parsed) return false;

    chars = parsed;
  } else {
    const match = value.toString().match(/\d/g);
    const digits = Array.isArray(match) ? match : [];

    if (digits.length !== 14) return false;

    chars = digits;
  }

  if (chars.length !== 14) return false;

  const values = chars.map(charToValue);

  const uniqueValues = new Set(values);
  if (uniqueValues.size === 1) return false;

  const calc = (x: number) => {
    const slice = values.slice(0, x);
    let factor = x - 7;
    let sum = 0;

    for (let i = x; i >= 1; i--) {
      const n = slice[x - i];
      sum += n * factor--;
      if (factor < 2) factor = 9;
    }

    const result = 11 - (sum % 11);

    return result > 9 ? 0 : result;
  };

  const checkDigits = values.slice(12);

  const digit0 = calc(12);
  if (digit0 !== checkDigits[0]) return false;

  const digit1 = calc(13);
  return digit1 === checkDigits[1];
}
